<template>
  <div class="route-view-card ma-0 pa-15 fill-height d-flex flex-column">
    <span class="titulo"> Confirme a medicação administrada </span>

    <v-row class="ma-0 mt-8 pa-0">
      <div class="subtitulo"> Drogas administradas no lote</div>
      <v-data-table hide-default-footer calculate-widths show-select :value="listaSelecao"
                    no-data-text="Não foram encontradas medicações aplicadas nesse lote"
                    item-key="id" class="full-width elevation-2 mt-4"
                    :headers.sync="headersMedicacao" :items-per-page="-1"
                    :items="listaMedicacao" multi-sort :sort-by="['dtInicioTratamento', 'dtLiberacaoAbate']"
                    @click:row="selecionarItem"
      >
        <template v-slot:item.dtInicioTratamento="{ item }">
          {{ item.dtInicioTratamento | dateFormat("DD/MM/Y") }}
        </template>

        <template v-slot:item.dtLiberacaoAbate="{ item }">
          {{ item.dtLiberacaoAbate | dateFormat("DD/MM/Y") }}
        </template>
        <template v-slot:item.blAtendeuCarencia="{ item }">
          {{ item.blAtendeuCarencia ? 'SIM' : 'NÃO' }}
        </template>
        <template v-slot:header.data-table-select="{  }">
          <div class="d-flex flex-nowrap">
            Confirme as medicações aplicadas
          </div>
        </template>
        <template v-slot:item.data-table-select="{ item, isSelected }">
          <div class="d-flex flex-nowrap align-center">
            <v-simple-checkbox color="#0090E9" @click="selecionarItem(item)" :value="isSelected" />
            <span class="confirmar-label mt-1 ml-2">Confirmar</span>
          </div>
        </template>

      </v-data-table>
    </v-row>

    <v-row class="ma-0 mt-8 pa-0">
      <div class="subtitulo full-width"> Vacinações</div>
      <v-data-table hide-default-footer calculate-widths show-select :items-per-page="-1" :value="listaSelecao"
                    no-data-text="Não foram encontradas vacinas aplicadas nesse lote"
                    item-key="id" class="elevation-2 mt-4" :sort-by="'dtInicioTratamento'"
                    :headers.sync="headersVacina" :items="listaVacina"
                    @click:row="selecionarItem"
      >
        <template v-slot:item.dtInicioTratamento="{ item }">
          {{ item.dtInicioTratamento | dateFormat("DD/MM/Y") }}
        </template>
        <template v-slot:item.blAtendeuCarencia="{ item }">
          {{ item.blAtendeuCarencia ? 'SIM' : 'NÃO' }}
        </template>
        <template v-slot:header.data-table-select="{  }">
          <div class="d-flex flex-nowrap">
            Confirme as doses aplicadas
          </div>
        </template>
        <template v-slot:item.data-table-select="{ item, isSelected }">
          <div class="d-flex flex-nowrap align-center">
            <v-simple-checkbox color="#0090E9" @click="selecionarItem(item)" :value="isSelected" />
            <span class="confirmar-label mt-1 ml-2">Confirmar</span>
          </div>
        </template>
      </v-data-table>
    </v-row>
  </div>
</template>

<script>
import {MODELS} from "../resources";
import {validationMixin} from "vuelidate";

export default {
  name: "MedicacaoBoletimSanitario",
  mixins: [validationMixin],
  validations() {
    if (this.step !== 2 || this.loading) return { listaSelecao: {}}

    this.validarBtnContinuar(this.listaSelecao.length === this.boletimSanitario.admFarmacos.length)
    return {
      listaSelecao: { lista: (selecoes) => selecoes.length === this.boletimSanitario.admFarmacos.length &&
            !this.loading}
    }
  },
  props: {
    btnContinuar: Boolean,
    step: Number,
    loading: Boolean,
    boletimSanitario: {
      type: Object,
      required: true
    },
  },
  data: () => ({
    headersMedicacao: MODELS.HEADERS_MEDICACAO,
    headersVacina: MODELS.HEADERS_VACINA,
    listaSelecao: [],
  }),
  computed: {
    listaMedicacao() {
      const listaFarmaco = this.boletimSanitario.admFarmacos.map((adm, idx) => _.extend(adm, {id: idx}))
      return listaFarmaco.filter(adm => !adm.blVacina)
    },
    listaVacina() {
      const listaFarmaco = this.boletimSanitario.admFarmacos.map((adm, idx) => _.extend(adm, {id: idx}))
      return listaFarmaco.filter(adm => adm.blVacina)
    },
  },
  methods: {
    selecionarItem(item) {
      this.listaSelecao =  _.xor(this.listaSelecao, [item])
    },
    validarBtnContinuar(value) {
      this.$emit('update:btnContinuar', value)
    }
  },
  watch: {
    '$v.$invalid'(value) {
      this.validarBtnContinuar(!value)
    },
    'boletimSanitario.admFarmacos'(value) {
      if (!value) return
      if (value.length === 0) this.listaSelecao = []
      this.listaSelecao = value.filter(admFarmaco => admFarmaco.blAdmFarmacoConfirmado)
    },
  },
}
</script>

<style scoped lang="scss">
.route-view-card {
  background-color: #F2F5F3;
}

.titulo {
  font-family: Roboto;
  font-size: 32px;
  color: #35565B;
  opacity: 0.8;
}

.subtitulo {
  font-family: Roboto;
  font-style: normal;
  font-weight: 500;
  font-size: 20px;
  letter-spacing: 0.15px;
  color: #35565B;
}

.label {
  font-family: Roboto;
  font-style: normal;
  font-weight: normal;
  font-size: 12px;
  color: #7B9596;
}

.confirmar-label {
  font-family: Roboto;
  font-style: normal;
  font-weight: normal;
  font-size: 14px;
  line-height: 14px;
  color: #799596;
}

.principio--ativo {
  max-width: 200px;
  white-space: break-spaces;
  display: flex;
}
</style>